"use strict";
// https://docs.oasis-open.org/odata/odata-json-format/v4.01/odata-json-format-v4.01.html#_Toc38457781
// support json format for batch request
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=batch.js.map